import { enqueueSnackbar } from "notistack";
import React, { useState } from "react";
import ConfirmComp from "src/components/shared/ConfirmComp";
import DeleteIcon from "src/components/shared/icon/DeleteIcon";
import UpdateIcon from "src/components/shared/icon/UpdateIcon";
import useAppGlobal from "src/context/useAppGlobal";
import { v4 as uuid } from "uuid";
import ProviderCreate from "../ProviderCreate";
import useProviderRemove from "src/hooks/setting/provider/useProviderRemove";
import ViewIcon from "src/components/shared/icon/ViewIcon";
import ProviderDetail from "../ProviderDetail";

export default function useProviderAction() {
  const { handleOpenDialog, closeDialog } = useAppGlobal();
  const [providerId, setProviderId] = useState();
  const { trigger: removeProvider } = useProviderRemove(providerId);

  const handleView = (item) => {
    handleOpenDialog({
      title: "Chi tiết Nhà cung cấp",
      content: <ProviderDetail item={item} />,
      size: "sm",
    });
  };

  const handleUpdateProvider = (item) => {
    handleOpenDialog({
      title: "Chỉnh sửa nhà cung cấp",
      size: "md",
      content: <ProviderCreate item={item} />,
    });
  };

  const handleRemoveProvider = async (item) => {
    const res = await removeProvider();
    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Thành công!", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };

  const action = [
    {
      id: uuid(),
      icon: <ViewIcon />,
      onClick: (item) => handleView(item),
      type: "icon",
    },
    {
      id: uuid(),
      icon: <UpdateIcon />,
      onClick: (item) => handleUpdateProvider(item),
      type: "icon",
    },
    {
      id: uuid(),
      icon: <DeleteIcon />,
      onClick: (item) => {
        setProviderId(item?._id);
        handleOpenDialog({
          content: (
            <ConfirmComp
              name={item?.name}
              onConfirm={() => handleRemoveProvider(item?._id)}
            />
          ),
          size: "md",
        });
      },
      type: "icon",
    },
  ];
  return action;
}
